import { ImplementingOfficerDetails as DefaultImplementingOfficerDetails } from "src/components/feature/Onboarding";

const ImplementingOfficerDetails = () => {
  return <DefaultImplementingOfficerDetails />;
};

export default ImplementingOfficerDetails;
